import './Theme.Box.Blank.scss';
export default 'ThemeBoxBlank';
